import { Box } from "@mui/material";
import { orange } from "@mui/material/colors";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { makeModeAwareAccent } from "@entrilia/shared/utilities/colorHelper";
import type { DataImportChangeRequest } from "../../../../../../api/types/dataImportTypes";
import GridCellValidationError from "../../../../../common/grid/GridCellValidationError";

interface Props {
  changeRequest: DataImportChangeRequest;
}

const DataImportChangeActionTag = ({ changeRequest }: Props) => {
  if (changeRequest.isExcluded) {
    return <StatusChip label="Excluded" color={(t) => makeModeAwareAccent(t, orange)} />;
  }

  if (changeRequest.hasValidationErrors) {
    return <StatusChip label="Validation Error" color={(t) => t.palette.error.main} />;
  }

  if (changeRequest.applicationError) {
    return (
      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <StatusChip label="Import Error" color={(t) => t.palette.error.main} />
        <GridCellValidationError error={changeRequest.applicationError} />
      </Box>
    );
  }

  switch (changeRequest.action) {
    case "CreateNew": {
      return <StatusChip label="New" color={(t) => t.palette.info.main} />;
    }
    case "UpdateExisting": {
      return <StatusChip label="Updated" color={(t) => t.palette.success.main} />;
    }
    case "DoNothing": {
      return <StatusChip label="Existing" color={(t) => t.palette.text.secondary} />;
    }
    case "Delete": {
      return <StatusChip label="Delete" color={(t) => t.palette.error.main} />;
    }
    default: {
      return null;
    }
  }
};

export default DataImportChangeActionTag;
